/**
 * Tenta encontrar um elemento no DOM pelo ID ou Name.
 * Ao encontrar, aplica foco e dispara um clique.
 *
 * @param selector - ID ou Name do elemento que se deseja buscar.
 */
export const focusAndClickElement = (selector: string): void => {
  if (!selector) return;

  let element = document.getElementById(selector);

  if (!element) {
    const elementsByName = document.getElementsByName(selector);
    if (elementsByName.length > 0) {
      element = elementsByName[0] as HTMLElement;
    }
  }

  if (element instanceof HTMLElement) {
    element.focus();
    if (typeof element.click === 'function') element.click();
  } else {
    console.warn(`Elemento com ID ou name "${selector}" não encontrado.`);
  }
};
